// removed by extract-text-webpack-plugin
module.exports = {"root":"Toolbox__root___31dkn","title":"Toolbox__title___MH01w","row":"Toolbox__row___1YMjG","colorPicker":"Toolbox__colorPicker___1hjhv","label":"Toolbox__label___2vTGv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/ContainerNoProps/Toolbox/Toolbox.scss
// module id = 983
// module chunks = 0